import Component from "../component.abstract"
import { getSingleInstanceByElement, getSingleInstanceByName, initialiseComponents } from '../../core'
import Selector from "../multiselect/select"
import SuggestInput from "../inputs/autocomplete/autocomplete"
import {getOffset} from "../helpers/html-utils"
import Facets from "../facets/facets"
import {hw} from "../helpers/paths"
import { numberWithSpace } from "../helpers/number"

interface BinderGenericProps {
    names: string[]
}

export default class BinderGeneric extends Component {
    private names: string[]
    private inputs: any = {}
    private bindFilter: HTMLInputElement
    private placeholder: Element
    private numberholder: Element
    private eraser: Element
    private i = 0;
    constructor(private props:BinderGenericProps, element: HTMLElement){
        super(props, element)
        this.names = this.props.names
        this.placeholder = this.element.querySelectorAll("[data-binder-gen-placeholder]")[0];
        this.numberholder = this.element.querySelectorAll("[data-binder-gen-number]")[0];
        this.eraser = this.element.querySelectorAll("[data-binder-gen-eraser]")[0];
        this.bindFilter = this.element.querySelector<HTMLInputElement>("#binderfilter");
    }
    mounted(): void {
        for(const name of this.names) {
            this.waitFor(name)
        }
        this.eraser.addEventListener('click',()=>{
            this.unselectAll()
             document.dispatchEvent(new Event('changefacet'));
        })
          if (this.bindFilter) {
            this.bindFilter.addEventListener("change", () => {
              setTimeout(() => {
               window.dispatchEvent(new Event("resize"));
              }, 10);
            });
          }
        if(this.element.classList.contains('receiver') && window.innerWidth < 767) {
            const divsearch = document.createElement('div');
            divsearch.classList.add('asSubmit');
            const svgns = "http://www.w3.org/2000/svg";
            const svgsearch: unknown = document.createElementNS(svgns, "svg");
            (<HTMLElement>svgsearch).setAttribute("data-load-url", hw.getBaseRessourcesUrl() + "/img/svg/search-icon.svg")
            divsearch.appendChild(<HTMLElement>svgsearch);
            this.element.after(divsearch);
            initialiseComponents();
        }
    }
    waitFor(name:string):void {
       const nameElement = document.getElementsByName(name)[0]
       const suggestInstance: SuggestInput = getSingleInstanceByElement("SuggestInput",nameElement)
       if(suggestInstance) {
           if(!this.inputs[name]) {
               this.inputs[name] = {"func" : this.bindSuggestInput, "instance" : suggestInstance}
               PubSub.subscribe("suggest-change",()=>{
                   this.bindAll()
               })
               this.bindAll()
           }
       }
       const selectorInstance: Selector = getSingleInstanceByElement("Selector",nameElement)
       if(selectorInstance) {
            if(!this.inputs[name]) {
               this.inputs[name] = {"func" : this.bindSelector, "instance" : selectorInstance}
               PubSub.subscribe("selector-option",()=>{
                   this.bindAll()
               })
               PubSub.subscribe("selector-group.ready",()=>{
                   this.bindAll()
               })
               this.bindAll()
           }
       }
    }
    unselectAll():void {
        const sels = [];
        for (const name of this.names) {
            if (this.inputs[name]) {
                // décocher option du select 
                this.inputs[name].instance.unselectAll(true);
                sels.push(this.inputs[name].instance);
            }
        }
        //coche distance par défaut
        if(document.getElementById('ray_button')) {
            document.getElementById('ray_button').nextElementSibling.querySelectorAll('ul li:first-child label')[0].classList.add("selected");
        }
        if(document.querySelectorAll('[name=ray]').length && window.innerWidth > 767){
            document.querySelectorAll('[name=ray] option')[0].setAttribute('selected', "true")
            const defaultDistance:HTMLElement =  document.querySelector('[name=ray]+input').nextElementSibling.querySelectorAll('label span.selected')[0] as HTMLElement
            defaultDistance.innerText = "Distance";
        }
        if(this.element.classList.contains('receiver')) {
            (<HTMLElement>this.placeholder).innerText = "Chef de projet, Vendeur en CDI, Norauto";
            this.element.classList.remove('activ');
        }
        if(document.querySelector('select[name=d]+input')) {
            document.querySelector('select[name=d]+input').nextElementSibling.querySelectorAll('ul li:first-child label')[0].classList.add("selected");
        }

        if (this.bindFilter) {
            this.bindFilter.checked = false;
        }
        
        const facetsInstance:Facets = getSingleInstanceByName("Facets");
        facetsInstance.changeAllLocations(sels)
        this.bindAll()
        document.dispatchEvent(new CustomEvent("deleteBinderTag"));

    }
    bindSuggestInput(instance:SuggestInput,self:BinderGeneric):void {
        const option = (<HTMLInputElement>instance.getElement()).value;
        self.bindOption(option,instance)
    }
    bindSelector(instance:Selector,self:BinderGeneric):void {
        const options = instance.getSelectedOptions()
        for(const option of options) {
            if(instance.multiple || instance.indexOf(option) > 0) {
                self.bindOption(option,instance)
            }
        }
    }
    bindOption(option:any,instance:SuggestInput|Selector):void|boolean {
        const wrapper = document.createElement("div");
        const span = document.createElement("span");
        span.classList.add("tw-typo-s");
        wrapper.classList.add("tw-border-grey-300", "tw-px-2", "tw-border", "tw-border-solid", "tw-rounded-[0.5rem]", "tw-text-center","tw-mr-2", "tw-relative")
        const labelregex = new RegExp("/", "g");
        const placeholderTest = new RegExp("Essayez", "g");
        const placeholderTestfull = new RegExp(
           "Chef de projet, Vendeur en CDI, Norauto",
           "g"
         );
        const createplaceholder = (labelS:string) => {
            if (labelS) {
                labelS = labelS.replace(labelregex, " • ");
                if(option.className === "msa") {
                    const formatLabel = numberWithSpace(parseInt(labelS));
                    const newLabel = "≥ " + formatLabel.toString() + " €";
                    labelS = newLabel;
                    wrapper.setAttribute("id","msa-tag");
                    wrapper.classList.add("tw-bg-purple-50","tw-f-border-purple-50","salary_tag");
                    wrapper.classList.remove("tw-border-grey-300");
                    wrapper.setAttribute("data-cy","salaryTag");
                    span.classList.add("tw-text-purple-500");
                } else if(option.parentElement.name === "t") {
                    if(labelS !== "Pas de télétravail") {
                        labelS = "Télétravail " + labelS.toLowerCase();
                    }
                }
                span.innerText = labelS;
            }
            wrapper.appendChild(span);
            this.placeholder.appendChild(wrapper); 
            const svgns = "http://www.w3.org/2000/svg";
            const cross = document.createElementNS(svgns, "svg");
            cross.setAttribute("data-load-url", hw.getBaseRessourcesUrl() + "/img/svg/close.svg");
            wrapper.appendChild(cross);
            initialiseComponents();

            cross.addEventListener("click", () => {
                 span.parentElement.remove(); 
                if(instance.name == "ray") {
                    document.getElementById(option.id).removeAttribute('selected');
                    const distance = document.querySelector('[name=ray]+input').nextElementSibling.querySelectorAll('label span.selected')[0] as HTMLElement
                    distance.innerText = "Distance";
                }
          
                if((<Selector>instance).unselectOption) {
                     (<Selector>instance).unselectOption(option, true);
                }
   
                if(instance.name == "f") {
                    (<Selector>instance).unselectOption(option.parentElement, true);
                } 
                document.dispatchEvent(new CustomEvent("deleteBinderTag"));
                
            })
         }
         let labelS:string
         if(this.element.classList.contains("receiver")) {
              if (option.tagName === undefined) {
                labelS = option;
              } else {
                labelS = option.innerText;
              }
            if(labelS !== "") {
                if(this.i > 0) {
                        (<HTMLElement>this.placeholder).innerText += " • "+labelS;
                } else {
                    if (
                        placeholderTest.test((<HTMLElement>this.placeholder).innerText) ||
                        placeholderTestfull.test((<HTMLElement>this.placeholder).innerText)
                    ) {
                        (<HTMLElement>this.placeholder).innerText = "";
                    }
                    (<HTMLElement>this.placeholder).innerText += " "+labelS;
                }
                this.i++
                this.element.classList.add('activ'); 
            }
         } else {
             if(option.tagName !== "OPTGROUP")  {
                if(instance.name == "ray" && (<HTMLInputElement>document.querySelectorAll('[name=l]')[0]).value === "") {
                    return false;
                }
                labelS = option.innerText;
                createplaceholder(labelS)
            }
         }
    }
    bindAll():void {
        if (this.bindFilter) {
            this.bindFilter.checked = false;
        }
        if((this.element.classList.contains('receiver') && this.element.classList.contains("activ")) || !this.element.classList.contains('receiver')) {
            this.placeholder.innerHTML = "";
        } 
        this.i = 0;
        for (const name of this.names) {
            if (this.inputs[name]) {
                this.inputs[name].func(this.inputs[name].instance, this);
            }
        }
        let over = 0;
        if(!this.element.classList.contains('receiver')) {
            const ploff = getOffset(this.placeholder);
            for (let i = 0; i < this.placeholder.children.length && over == 0; i++) {
                const off = getOffset(this.placeholder.children[i]);
                if (off.top >= ploff.bottom) {
                    over = i;
                }
            }
        }
        if (over == 0) {
            this.numberholder.parentElement.style.display = "none";
        } else {
            over = this.placeholder.children.length - over;
            (<HTMLElement>this.numberholder).innerText = over + "";
            this.numberholder.parentElement.style.display = "block";
        }
        if(!this.element.classList.contains('receiver')) {
             const sister = this.numberholder.parentElement.nextElementSibling as HTMLElement
            if (this.placeholder.children.length == 0) {
                sister.style.display = "none";
                this.element.classList.remove('activ');
            } else {
                sister.style.display = "block";
                this.element.classList.add('activ');
            }
        } else {
            if (!this.element.classList.contains("activ")) {
                const placeholder = document
                .querySelectorAll("[name=k]")[0]
                .getAttribute("data-placeholder");
                if(placeholder !== null) {
                    const placeholderArray = placeholder.split(",");
                    if (placeholderArray.length > 1) {
                        let $timing = 0;
                        const txt = "Essayez avec : ";
                        let j:number

                        const changePlaceholder = () => {
                            const max = placeholderArray.length - 1;
                            if (this.element.classList.contains("activ")) {
                                stopTest()   
                                return false;    
                            }
                            let i = getRandomIntInclusive(0, max);
                            if (i != j) {
                                const placeh = txt + placeholderArray[i];
                                (<HTMLElement>this.placeholder).innerText = placeh;
                                j = i;
                            } else {
                                if (j < max) {
                                    i = j + 1;
                                } else {
                                    i = j - 1;
                                }
                                j = i;
                                const placeh = txt + placeholderArray[i];
                                (<HTMLElement>this.placeholder).innerText = placeh;
                            }
                            $timing++;
                            if ($timing > 60) {
                                stopTest();
                                let placeholderfinal = "";

                                for (let z = 0; z < placeholderArray.length; z++) {
                                    if (z == placeholderArray.length - 1) {
                                        placeholderfinal += placeholderArray[z];
                                    } else {
                                        placeholderfinal += placeholderArray[z] + ", ";
                                    }
                                }
                                 (<HTMLElement>this.placeholder).innerText = placeholderfinal;
                            }
                        }
                        const retest = setInterval(changePlaceholder, 2000);
                        const stopTest = () => {
                             clearInterval(retest);
                        }
                        const getRandomIntInclusive = (min:number,max:number):number => {
                            min = Math.ceil(min);
                            max = Math.floor(max);
                            return Math.floor(Math.random() * (max - min + 1)) + min;
                        }

                    }
                }
            }
        }

        setTimeout(() => {
          window.dispatchEvent(new Event("resize"));
        }, 10);
    }
}